<template>
  <van-action-sheet
    :value="visible"
    :title="title"
    @cancel="$emit('update:visible', false)"
    @click-overlay="$emit('update:visible', false)"
  >
    <div class="page-rnr-action-sheet">
      <ErrorWrap :error-message="errorMessage" :error="!!errorMessage">
        <van-field
          v-model="inputValue"
          :clearable="true"
          :label="label"
          :maxlength="maxlength"
          clear-trigger="always"
          :placeholder="`请输入${label}`"
          input-align="right"
          @blur="validateInput(inputValue)"
        />
      </ErrorWrap>
      <van-button
        :disabled="btnDisable"
        type="primary"
        class="page-rnr-action-sheet-btn"
        round
        color="linear-gradient(120deg, #000 0%, #000 97%)"
        block
        @click="handleConfirmInput"
      >确定</van-button>
    </div>
  </van-action-sheet>
</template>

<script>
import ErrorWrap from './ErrorWrap'
import { validate } from '@/utils/validate'

export default {
  name: 'InputActionSheet',
  components: { ErrorWrap },
  props: {
    title: {
      type: String,
      default: ''
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'VIN码'
    }
  },
  data() {
    return {
      upperCaseValue: '',
      errorMessage: ''
    }
  },
  computed: {
    // 小写自动转大写
    inputValue: {
      get() {
        return this.upperCaseValue
      },
      set(val) {
        if (this.label === 'VIN码') {
          this.upperCaseValue = val.toUpperCase()
        } else {
          this.upperCaseValue = val
        }
      }
    },
    maxlength: {
      get() {
        if (this.label === 'VIN码') {
          return 17
        } else {
          // ICCID长度一般是18-22位
          return 22
        }
      }
    },
    btnDisable() {
      // 校验失败的字段
      const [failField] = this.validateField(this.inputValue)
      // 错误信息
      return !!failField
    }
  },
  watch: {
    /**
     * 监听打开弹框事件
     */
    visible() {
      if (this.visible) {
        this.inputValue = this.data
      }
    }
  },
  methods: {
    /**
     * 校验字段值是否合法
     * @param value 字段输入的值
     */
    validateField(value) {
      // 当前需要校验的字段
      const fields = {}
      const fieldRules = []
      // 遍历规则
      Object.keys(this.rules).forEach(ruleKey => {
        fields[ruleKey] = value
        fieldRules.push(ruleKey)
      })
      // 返回校验结果
      return validate(fields, fieldRules)
    },

    /**
     * 校验用户输入
     * @param value 字段输入的值
     */
    validateInput(value) {
      // 错误字段和错误值
      const [failField, failMessage] = this.validateField(value)
      // 错误信息
      this.errorMessage = failField ? failMessage : ''
    },

    /**
     * 确认用户输入的内容
     */
    handleConfirmInput() {
      // 触发submit方法
      this.$emit('submit', this.inputValue)
      // 关闭弹框
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss">
.page-rnr-action-sheet {
  padding: 30px;
  .page-rnr-action-sheet-title {
    color: #242424;
    font-size: 32px;
    font-weight: 500;
    line-height: 45px;
    padding: 0 0 0 24px;
  }
  .van-cell {
    background-color: transparent;
    padding: 0;

    &.van-field {
      background-color: transparent;
      padding: 44px 26px;
      position: relative;
      .van-field__label {
        color: #242424;
        font-size: 32px;
        font-weight: 400;
        width: 120px;
        height: 45px;
      }
      .van-cell__value {
        height: 45px;
        .van-field__control {
          color: #242424;
          font-size: 32px;
        }
        &.van-field__value {
          position: relative;
          .van-field__error-message {
            position: absolute;
            left: -220px;
            bottom: -90px;
          }
        }
        .van-field__clear {
          margin-left: 30px;
        }
      }
    }
    &.van-cell--required {
      .van-cell__title {
        span {
          padding-left: 20px;
        }
      }
      &:before {
        left: 0px;
        font-size: 16px;
      }
    }
    .van-cell__title {
      span {
        color: #242424;
        font-size: 32px;
        font-weight: 400;
      }
    }
    .van-cell__label {
      margin-top: 36px;
    }
    &:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0px;
      bottom: 0;
      left: 0px;
      border-bottom: 1PX solid #ebedf0 !important;
      transform: scaleY(.5);
    }
  }
  .page-rnr-action-sheet-btn {
    margin: 112px 0px 88px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InputActionSheet.vue